import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

const ItemTreeView = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [subItems, setSubItems] = useState({});
  const [innerSubItems, setInnerSubItems] = useState({});
  const [deepInnerSubItems, setDeepInnerSubItems] = useState({});
  const [finalItems, setFinalItems] = useState({});


  /////////////////////////////////////////////////////////////
      const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
        const permsLoaded = !!rawPerms;
        
        //✅ Permission checks (safe even if perms not yet loaded; will be false)
        const canEntry = hasPermission("Item Tree View", "entry");
        const canView = hasPermission("Item Tree View", "view");
  /////////////////////////////////////////////////////////////
  

  useEffect(() => {
    fetchData();
  }, []);

  const showProgressBar = (title = "Loading") => {
    Swal.fire({
      title,
      html: `
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 14px;">Please wait...</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        const style = document.createElement("style");
        style.innerHTML = `
          @keyframes progressBar {
            0% { width: 0% }
            50% { width: 100% }
            100% { width: 0% }
          }
        `;
        document.head.appendChild(style);
      },
    });
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/itemTreeView_list");
      setData(response.data.TreeViewHeading);
      setFilteredData(response.data.TreeViewHeading);
    } catch (error) {
      console.error("Error fetching item tree data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubItems = async (code) => {
    try {
      showProgressBar("Loading Sub Items...");
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemTreeView_subitems/${code}`);
      setSubItems((prev) => ({ ...prev, [code]: response.data.subItems || [] }));
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching sub-items:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Error fetching Sub Items. Please try again",
      });
    }
  };

  const fetchInnerSubItems = async (code) => {
    try {
      showProgressBar("Loading Inner Sub Items...");
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemTreeView_innersub/${code}`);
      setInnerSubItems((prev) => ({ ...prev, [code]: response.data.finalSubItems || [] }));
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching inner sub-items:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Error fetching Inner Sub Items. Please try again",
      });
    }
  };

  const fetchDeepInnerSubItems = async (code) => {
    try {
      showProgressBar("Loading Deep Inner Sub Items...");
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemTreeView_deepInner/${code}`);
      setDeepInnerSubItems((prev) => ({ ...prev, [code]: response.data.finalSubItems || [] }));
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching deep inner sub-items:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Error fetching Deep Inner Sub Items. Please try again",
      });
    }
  };

  const fetchFinalItems = async (code) => {
    try {
      showProgressBar("Loading Final Items...");
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemTreeView_final/${code}`);
      setFinalItems((prev) => ({ ...prev, [code]: response.data.finalSubItems || [] }));
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error("Error fetching final items:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Error fetching Final Items. Please try again",
      });
    }
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);
    if (term === "") {
      setFilteredData(data);
      return;
    }
    const filtered = data.filter((item) =>
      (String(item.code || "").toLowerCase().includes(term) ||
        String(item.itemName || "").toLowerCase().includes(term))
    );
    setFilteredData(filtered);
  };

  const toggleDropdown = (index, code) => {
    if (openDropdown === index) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown(index);
      if (!subItems[code]) fetchSubItems(code);
    }
  };

  const toggleInnerSub = (code) => {
    if (innerSubItems[code]) {
      setInnerSubItems((prev) => ({ ...prev, [code]: null }));
    } else {
      fetchInnerSubItems(code);
    }
  };

  const toggleDeepInnerSub = (code) => {
    if (deepInnerSubItems[code]) {
      setDeepInnerSubItems((prev) => ({ ...prev, [code]: null }));
    } else {
      fetchDeepInnerSubItems(code);
    }
  };

  const toggleFinalItems = (code) => {
    if (finalItems[code]) {
      setFinalItems((prev) => ({ ...prev, [code]: null }));
    } else {
      fetchFinalItems(code);
    }
  };

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">Item Code Classification</h2>
          <Time />
        </section>

        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by Code or Item Name"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>


{canEntry && (
        <div className="add-new-container">
          <Link to={`/inventory/add_Item_Category`}>
            <button className="add-new-btn">
              <i className="fa-solid fa-plus"></i> Add Category
            </button>
          </Link>
        </div>
)}

        {loading ? (
          <p className="loading-text">Loading data, please wait...</p>
        ) : filteredData.length > 0 ? (
          <div className="itemTree-container">
            {filteredData.map((item, index) => (
              <div key={index} className="itemTree-item">
                <div className="itemTree-heading" onClick={() => toggleDropdown(index, item.code)}>
                  <span className="itemTree-arrow">{openDropdown === index ? "▼" : "▶"}</span>
                  <span className="itemTree-node">{item.code} - {item.itemName}</span>
                </div>

                {openDropdown === index && (
                  <div className="itemTree-dropdown">
                    {subItems[item.code]?.length > 0 ? (
                      subItems[item.code].map((sub, subIndex) => (
                        <div key={subIndex} className="itemTree-subItem">
                          <div className="itemTree-subHeading" onClick={() => toggleInnerSub(sub.code)}>
                            <span className="itemTree-arrow">{innerSubItems[sub.code] ? "▼" : "▶"}</span>
                            <span>{sub.code} - {sub.itemName}</span>
                          </div>

                          {innerSubItems[sub.code] && (
                            <div className="itemTree-finalDropdown">
                              {innerSubItems[sub.code].map((inner, innerIndex) => (
                                <div key={innerIndex} className="itemTree-subItem">
                                  <div className="itemTree-subHeading" onClick={() => toggleDeepInnerSub(inner.code)}>
                                    <span className="itemTree-arrow">{deepInnerSubItems[inner.code] ? "▼" : "▶"}</span>
                                    <span>{inner.code} - {inner.itemName}</span>
                                  </div>

                                  {deepInnerSubItems[inner.code] && (
                                    <div className="itemTree-finalDropdown">
                                      {deepInnerSubItems[inner.code].map((deep, deepIndex) => (
                                        <div key={deepIndex} className="itemTree-subItem">
                                          <div className="itemTree-subHeading" onClick={() => toggleFinalItems(deep.code)}>
                                            <span className="itemTree-arrow">{finalItems[deep.code] ? "▼" : "▶"}</span>
                                            <span>{deep.code} - {deep.itemName}</span>
                                          </div>

                                          {finalItems[deep.code] && (
                                            <div className="itemTree-finalDropdown">
                                              {finalItems[deep.code].length > 0 ? (
                                                finalItems[deep.code].map((itemFinal, finalIndex) => (
                                                    <p className="itemTree-finalItem">{itemFinal.code} - {itemFinal.itemName}</p>
                                                ))
                                              ) : (
                                                <p>No Items Available</p>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <p>No Sub-items Available</p>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
};

export default ItemTreeView;
